// extracted by mini-css-extract-plugin
export default {"notify-cumulus":"_36I83F-yWI5f-a5BsIOpjJ"};